import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, isRef as _isRef, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-center" }
const _hoisted_2 = {
  key: 0,
  class: "mb-1"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Tags',
  setup(__props) {


const { control, inputModel, handleUpdate } = inject('input') as InputInjection

// Show append if sync, flag, or help is present
const ui = useUiStore()
const showAppend = computed(() => {
  return (ui.showSync && control.value.sync) || control.value.flag || control.value.help
})


return (_ctx: any,_cache: any) => {
  const _component_hy_inputs_sync_marker = _resolveComponent("hy-inputs-sync-marker")!
  const _component_hy_inputs_help_marker = _resolveComponent("hy-inputs-help-marker")!
  const _component_v_combobox = _resolveComponent("v-combobox")!

  return (_openBlock(), _createBlock(_component_v_combobox, _mergeProps({
    modelValue: _unref(inputModel),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(inputModel) ? (inputModel).value = $event : null))
  }, _unref(control), {
    chips: "",
    "closable-chips": "",
    multiple: "",
    "onUpdate:modelValue": _unref(handleUpdate)
  }), _createSlots({ _: 2 }, [
    (_unref(showAppend))
      ? {
          name: "append",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.$ui.showSync && _unref(control).sync)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_hy_inputs_sync_marker, {
                      sources: _unref(control).sync
                    }, null, 8, ["sources"])
                  ]))
                : _createCommentVNode("", true),
              (_unref(control).help)
                ? (_openBlock(), _createBlock(_component_hy_inputs_help_marker, {
                    key: 1,
                    "help-prompt": _unref(control).help
                  }, null, 8, ["help-prompt"]))
                : _createCommentVNode("", true)
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1040, ["modelValue", "onUpdate:modelValue"]))
}
}

})